var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPencilWithDoc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "transparent",
  viewBox: "0 0 16 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.4,
  d: "M8.417 18.335h4.584a1.667 1.667 0 0 0 1.666-1.667V5.835l-4.166-4.167H3a1.667 1.667 0 0 0-1.667 1.667v7.916m8.333-9.583v3.333a1.667 1.667 0 0 0 1.667 1.667h3.333M9.15 13.023a1.77 1.77 0 0 0-2.503-2.503L2.47 14.696a1.67 1.67 0 0 0-.422.712L1.351 17.8a.417.417 0 0 0 .517.516l2.392-.697c.269-.079.513-.224.711-.422z"
})));
export default SvgPencilWithDoc;